import React, { useState, useEffect, useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChatContacts from "./ChatContact";
import ChatMessages from "./ChatMessage";
import ChatSendMessage from "./ChatSendMessage";
import { fetchOnlyData } from "../../utility/managerApi";
import { useQuery } from "@tanstack/react-query";

const ChatPopup = ({ openMessage, setOpenMessage, setTotalUnreadMessages }) => {
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedContactName, setSelectedContactName] = useState(null);

  const { data, refetch } = useQuery({
    queryKey: ["managerContacts"],
    keepPreviousData: true,
    retry: false,
    staleTime: 14 * 1000,
    refetchInterval: 15 * 1000,
    refetchOnMount: false,
    queryFn: () => fetchOnlyData("chats/contacts"),
  });

  const allUnread = useMemo(() => {
    return (
      data?.map(
        (items) =>
          items?.messages.filter(
            (item) => Number(item?.is_read) === 0 && item.role === "receiver"
          ).length
      ) || []
    );
  }, [data]);

  useEffect(() => {
    const sum = Array.isArray(allUnread)
      ? allUnread.reduce((acc, count) => acc + count, 0)
      : 0;

    setTotalUnreadMessages(sum);
  }, [allUnread, setTotalUnreadMessages]);

  const handleClose = () => {
    setOpenMessage(false);
    setSelectedContact(null);
  };

  const handleContactClick = (contactId, name) => {
    setSelectedContact(contactId);
    setSelectedContactName(name);
  };

  const handleRefetch = () => {
    setTimeout(() => {
      refetch();
    }, 2000);
  };

  return (
    openMessage && (
      <div className="pt-2 bg-gray-100 absolute right-2 top-16 mt-2 w-full overflow-x-auto md:w-[34rem] shadow-lg rounded-lg z-30  overflow-hidden">
        <div className="flex justify-end pr-2  border-b-2">
          <CancelIcon
            onClick={handleClose}
            sx={{
              fontSize: { xs: 20, sm: 15, md: 30 },
            }}
            className="cursor-pointer text-black mb-2"
          />
        </div>

        <div className=" flex h-[480px]">
          {/* Contact List */}
          <div className="w-1/4 bg-gray-100 p-4 border-r text-gray-800 border-gray-200 overflow-y-auto">
            <h2 className="font-bold mb-4 text-sm md:text-base ">Contacts</h2>
            <ChatContacts handleContactClick={handleContactClick} data={data} />
          </div>

          {/* Chat Screen */}
          <div className="w-3/4 flex bg-white flex-col">
            <div className="p-4 border-b border-gray-200">
              <h2 className="font-bold text-gray-800">
                {selectedContactName ? (
                  <div>
                    {" "}
                    <AccountCircleIcon /> {selectedContactName}
                  </div>
                ) : (
                  "Select a contact"
                )}
              </h2>
            </div>
            <ChatMessages
              selectedContact={selectedContact}
              handleRefetch={handleRefetch}
            />
            <ChatSendMessage selectedContact={selectedContact} />
          </div>
        </div>
      </div>
    )
  );
};

export default ChatPopup;
